import { UNASSIGN_DIRECTOR_FROM_SOURCE } from 'actions/Types';
import { withCurrentParams } from 'actions/utils';
import { EMPTY_THUMBNAIL, UNASSIGNED } from 'utils/broadcastSourceHelper';
import { SOURCE_CREATE } from 'store/eventConstants';

export default () => {
  return withCurrentParams(
    (dispatch, { broadcastId, teamId, eventId }, getState, socket) => {
      const {
        broadcastSources: { sources }
      } = getState();
      const attendeeId = sessionStorage.getItem(
        `CURRENT_DIRECTOR_ATTENDEE-${broadcastId}`
      );

      if (!attendeeId) return;

      const directorSource = sources.find(
        source => source.value === attendeeId
      );

      if (!directorSource) return;

      const changes = {
        value: UNASSIGNED,
        thumbnail: EMPTY_THUMBNAIL
      };

      /**
       * Only dispatch an action when director source exists
       */
      const action = {
        type: UNASSIGN_DIRECTOR_FROM_SOURCE,
        request: async apiClient => {
          await apiClient.broadcast.updateSource(
            teamId,
            eventId,
            broadcastId,
            directorSource._id,
            changes
          );
          // notify other directors
          socket.emit(SOURCE_CREATE, {
            broadcastId,
            notifyingDirector: attendeeId
          });
          // The request method should return a value
          return false;
        }
      };

      dispatch(action);
    }
  );
};
